export enum CodeErreur {
    LIMITE_DEMO_ATTEINTE = 'LIMITE_DEMO_ATTEINTE',
    LIMITE_DEMO_CONTENUS_ATTEINTE = 'LIMITE_DEMO_CONTENUS_ATTEINTE',
    LIMITE_DEMO_CREATION_ATTEINTE = 'LIMITE_DEMO_CREATION_ATTEINTE',
    LIMITE_DEMO_TYPE_CONTENU_ATTEINTE = 'LIMITE_DEMO_TYPE_CONTENU_ATTEINTE',
    LIMITE_DEMO_VISIONNEMENTS_ATTEINTE = 'LIMITE_DEMO_VISIONNEMENTS_ATTEINTE'
}

const DEMO_LIMIT_ERROR_CODES: CodeErreur[] = [
    CodeErreur.LIMITE_DEMO_ATTEINTE,
    CodeErreur.LIMITE_DEMO_CONTENUS_ATTEINTE,
    CodeErreur.LIMITE_DEMO_CREATION_ATTEINTE,
    CodeErreur.LIMITE_DEMO_TYPE_CONTENU_ATTEINTE,
    CodeErreur.LIMITE_DEMO_VISIONNEMENTS_ATTEINTE
];

export function isDemoLimitErrorCode(codeErreur: string): boolean {
    return DEMO_LIMIT_ERROR_CODES.includes(codeErreur as CodeErreur);
}
